import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import CommonBanner from '../common/Banner';

const ItPowers: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('ItPowers');
    return (
        <div className="ItPowers GtmModuleData-section" data-section-id="ItPowers" id="ItPowers">
            <CommonBanner
                title={t('title')}
                pc="https://websiteoss.ecoflow.com/upload/image/1753683035852/pc.jpg"
                pad="https://websiteoss.ecoflow.com/upload/image/1753683035964/pad.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1753683036214/h5.jpg"
            />
        </div>
    );
};

export default ItPowers;
